import { render, staticRenderFns } from "./skillList.vue?vue&type=template&id=06eb20c4&"
import script from "./skillList.vue?vue&type=script&lang=js&"
export * from "./skillList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports